import { render, staticRenderFns } from "./ReportImagePreview.vue?vue&type=template&id=147cf89c&scoped=true"
import script from "./ReportImagePreview.vue?vue&type=script&lang=js"
export * from "./ReportImagePreview.vue?vue&type=script&lang=js"
import style0 from "./ReportImagePreview.vue?vue&type=style&index=0&id=147cf89c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147cf89c",
  null
  
)

export default component.exports